import React from "react";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";
import classNames from "classnames/bind";
import { graphql, useStaticQuery } from "gatsby";
import { getLangPrefixedPath, getPrefixedPathByPageType } from "@v4/utils/pathPrefix";
import * as socialStyles from "./socialsharing.css";

// Icons for sharing components
import FacebookSVG from "../../assets/svg/social-facebook.inline.svg";
import LinkedinSVG from "../../assets/svg/social-linkedin.inline.svg";
import TwitterSVG from "../../assets/svg/social-x.inline.svg";

const SocialSharing = ({ title, slug, contentType = "", locale }) => {
    const cx = classNames.bind(socialStyles);

    const { site } = useStaticQuery(
        graphql`
            query {
                site {
                    siteMetadata {
                        siteUrl
                    }
                }
            }
        `
    );

    const generateSocialSharingLink = (title, slug, contentType, locale) => {
        const domain = site.siteMetadata.siteUrl ?? `https://www.talend.com`;
        const shareTitle = title;
        let shareUrl = getPrefixedPathByPageType(slug, contentType);
        shareUrl = getLangPrefixedPath(shareUrl, locale);
        shareUrl = `${domain}${shareUrl}`;

        return { shareTitle, shareUrl };
    };

    const { shareTitle, shareUrl } = generateSocialSharingLink(title, slug, contentType, locale);

    return (
        <ul className={cx("socials")}>
            <li>
                <FacebookShareButton
                    className={cx("socialsShare", "socialsShareFacebook")}
                    title={shareTitle}
                    url={shareUrl}
                >
                    <FacebookSVG />
                </FacebookShareButton>
            </li>
            <li>
                <LinkedinShareButton
                    className={cx("socialsShare", "socialsShareLinkedIn")}
                    title={shareTitle}
                    url={shareUrl}
                >
                    <LinkedinSVG />
                </LinkedinShareButton>
            </li>
            <li>
                <TwitterShareButton
                    className={cx("socialsShare", "socialsShareTwitter")}
                    title={shareTitle}
                    url={shareUrl}
                >
                    <TwitterSVG />
                </TwitterShareButton>
            </li>
        </ul>
    );
};

export default SocialSharing;
